import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="w-full bg-brand-bg pt-20 md:pt-28 pb-8 md:pb-10 px-6" data-id="element-149">
      <div className="max-w-5xl mx-auto text-center" data-id="element-150">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} data-id="element-151">
          <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold text-brand-green uppercase tracking-wide" data-id="element-152">
            Generá ingresos extra YA!
          </h1>

          <p className="mt-6 text-xl md:text-2xl text-brand-dark/70 leading-relaxed max-w-2xl mx-auto" data-id="element-153">
            Descubrí cuánto facturé en los últimos meses con
            <span className="font-semibold text-brand-green" data-id="element-154">
              {' '}
              1 solo producto{' '}
            </span>
            vendiendo por internet y como podés hacerlo vos
          </p>

          <p className="mt-3 text-lg md:text-xl text-brand-dark/80 font-medium max-w-2xl mx-auto" data-id="element-155">
            Te doy el{' '}
            <span className="font-bold text-brand-green" data-id="element-156">VERDADERO</span> paso a
            paso para copiar y pegar.
          </p>
        </motion.div>

        <motion.div className="mt-10" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease: 'easeOut',
        delay: 0.15
      }} data-id="element-157">
          <p className="text-lg font-semibold text-brand-green mb-4 uppercase tracking-wider" data-id="element-158">
            Mirá el video 👇
          </p>

          <div className="relative w-full mx-auto rounded-2xl bg-brand-card border border-white/10" style={{
          paddingBottom: '65%'
        }} data-id="element-159">
            <iframe src="https://fast.wistia.net/embed/iframe/g2unxd1ate?seo=true&videoFoam=true" title="Video de presentación" allow="autoplay; fullscreen" allowFullScreen className="absolute top-0 left-0 w-full h-full rounded-2xl" style={{
            border: 'none'
          }} data-id="element-160" />
          </div>
        </motion.div>
      </div>
    </section>;
}